// Confirm destructive removal of a user from the realm.
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  useTheme,
} from "@mui/material";
import { tokens } from "../../../theme";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

const RemoveUserModal = ({ open, user, onClose, onConfirm }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  if (!user) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: 2, maxWidth: 460 } }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, color: "#dc2626", fontWeight: 700, fontSize: "1rem" }}>
        <WarningAmberOutlinedIcon sx={{ fontSize: 20 }} />
        Remove {user.name}?
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: colors.grey[400], fontSize: "0.8125rem" }}>
          This revokes <strong>{user.name}</strong>'s access to the{" "}
          <Box component="span" sx={{ fontWeight: 600 }}>federatex</Box> realm in Keycloak. All
          active sessions are terminated immediately. This cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, px: 3 }}>
        <Button onClick={onClose} sx={{ color: colors.grey[400] }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onConfirm(user)}
          sx={{
            backgroundColor: "#dc2626",
            "&:hover": { backgroundColor: "#b91c1c" },
          }}
        >
          Remove user
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveUserModal;
